import { CONTAINERS } from '../variables/containers';
import { BREAKPOINTS } from '../variables/breakpoints';
import { forOwn } from 'lodash';

/* USAGE */
/*
import styled from 'styled-components';
import { setContainer } from '@titelmedia/bricks-theme/lib/utilities/layout';

export const Container = styled.div`
  ${setContainer({size: 'lg'})}
`;
// possible values: 'sm', 'md', 'lg'
*/

export const setContainer = ({ size }) => {
  let style = `
    padding: 0px 20px;
    margin: 0 auto;
  `;

  let useSize = size || 'md';
  if (CONTAINERS[useSize]) {
    style += `max-width: ${CONTAINERS[useSize].xs};`;
    forOwn(CONTAINERS[useSize], (b, breakpointKey) => {
        forOwn(BREAKPOINTS, (bc, breakpointKeyc) => {
            if (breakpointKey == breakpointKeyc) {
                      style += `
                @media (min-width: ${bc}px) {
                    max-width: ${CONTAINERS[useSize][breakpointKey]};
                }
            `;
            };
        });
    });
}
  return style;
};
